<template>
  <div
    v-if="!$permits.has('accessToProVersions')"
    class="roomy message"
    style="--message-background: var(--fa-yellow); --message-border-width: 0"
  >
    <div class="display-flex flex-column tablet:flex-row flex-items-start">
      <span
        class="tag yellow"
        style="--tag-background: var(--fa-dk-yellow)"
      >
        Pro
        <span class="sr-only">Plan Required</span>
      </span>
      <div class="margin-top-md tablet:margin-top-0 tablet:margin-left-lg">
        <h3 class="h5 margin-bottom-4xs"><slot /></h3>
        <div class="line-length-lg">
          <slot name="message">
            <p>
              This is a Pro feature so you'll need to
              <site-link :to="{ name: 'plans' }">grab a Pro-level plan</site-link>
              to use it. You'll also get thousands more icons, access to services, and support! Already got a plan?
              <site-link :to="{ name: 'account' }">Sign in!</site-link>
            </p>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'ProAlert'
  }
</script>
